import { get } from '../libs/Axios';
import { DataLayerUtils } from '../utilities/DataLayer';
import BaseComponent from '../abstracts/BaseComponent';

export default class WishlistComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.ADD_TO_WISHLIST_EVENTS.modified]: this.updateIcon
    };
  }

  get CLASSES() {
    return {
      full: 'is-full'
    };
  }

  constructor(element) {
    super(element);
  }

  async checkWishlistList() {
    let size = 0;
    try {
      // qui chiamiamo la wishlist per sapere se ci sono elementi
      const { data } = await get(this.$options.endpoint);

      size = data.size;
    } catch (e) {
      console.error(e);
    }

    return size;
  }

  async updateIcon({ pid }) {
    try {
      const size = await this.checkWishlistList();
      const wishlistDatalayer = window.dataLayer.find(el => el.eventCategory === 'wishlist_created');
      if (Number(this.$el.dataset.size) === 0 && size !== 0 && !wishlistDatalayer) {
        DataLayerUtils.push({
          gaHitType: 'event',
          event: 'goal_event',
          eventCategory: 'wishlist_created',
          eventAction: pid
        });
      }
      this.$el.dataset.size = size;
      if (size > 0) {
        this.$el.classList.add(this.CLASSES.full);
      } else {
        this.$el.classList.remove(this.CLASSES.full);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
